import Edit from '@ixigo/icons/EditFilled';
import IconButton from '@ixigo/iui/IconButton';
import Typography from '@ixigo/iui/Typography';
import type { TripDetailsCardMode } from '.';
import { Item as CabCard, type CabCardProps } from './cabCard';
import {
	WaypointTimeline,
	type WaypointTimelineProps,
} from './waypoint-timeline';

export interface TripDetailsCardProps extends WaypointTimelineProps {
	cabInfo?: CabCardProps;
	/** Custom class name */
	className?: string;
	onClick?: () => void;
	mode?: TripDetailsCardMode;
}

export function TripDetailsCard({
	cabInfo,
	className = '',
	onClick,
	mode,
	...waypointTimelineProps
}: TripDetailsCardProps) {
	const { rideDetails } = waypointTimelineProps;
	const { pickup, drop } = rideDetails;
	const sectionTitle =
		pickup.type === 'airport'
			? 'Airport Pick-up'
			: drop.type === 'airport'
				? 'Airport Drop-off'
				: 'Ride Detail';

	return (
		<div
			className={`relative rounded-[15px] border border-tertiary bg-primary overflow-hidden ${className}`}
		>
			<div className="flex flex-col gap-y-10 p-15 pb-5">
				<Typography
					variant="h6"
					fontWeight="medium"
					className="flex items-center justify-between"
				>
					{sectionTitle}
					{mode === 'Edit' && (
						<IconButton onClick={onClick} size="sm">
							<Edit className="size-6 shrink-0" />
						</IconButton>
					)}
				</Typography>
				<WaypointTimeline {...waypointTimelineProps} />
			</div>
			{cabInfo && <CabCard {...cabInfo} imageUrl={cabInfo.imageUrl} />}
		</div>
	);
}

export default TripDetailsCard;
